"use strict";
/**
 * 动态表单的字段定义契约
 * -----------------------------------------------------------------------------
 * 放 `shared` 的原因与权限码、错误码相同：**两端渲染器与校验器必须用同一份字面量**。
 * 前端据此渲染、服务端据此校验，任何一侧偷偷加类型都会让另一侧渲染/校验落空。
 *
 * 权威文档：`docs/03-architecture/03-扩展机制.md` §3（结构 / 类型 / 编辑分级 / 条件显示）。
 *
 * ⚠️ 这里是**纯声明**：不含任何可执行逻辑（表达式 / 脚本 / 公式）——
 * 扩展机制 §5 明确禁止在 Schema 中存放业务逻辑。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_KEY_PATTERN = exports.VisibleWhenOperator = exports.FieldEditable = exports.UPLOAD_MAX_COUNT_LIMIT = exports.UPLOAD_DEFAULT_MAX_COUNT = exports.UPLOAD_FIELD_TYPES = exports.OPTION_FIELD_TYPES = exports.PRICE_ELIGIBLE_FIELD_TYPES = exports.FieldType = void 0;
/** 字段类型（§3.2）
 *  ⚠️ **D-05 已裁决（2026-10-16）**：邮寄地址承载形态 = **3 个级联选择（省 / 市 / 区）
 *  + 1 个详细地址文本**，封装为**一个** `region` 字段类型（`FieldType.REGION`），
 *  取值见 `region.ts` 的 `RegionValue`（三级 6 位行政区划码 + `detail`）。
 *  码表与查询逻辑在 `./region.ts`，三端共用。 */
exports.FieldType = {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    NUMBER: 'number',
    DATE: 'date',
    SELECT: 'select',
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
    BOOLEAN: 'boolean',
    UPLOAD: 'upload',
    PHONE: 'phone',
    IDCARD: 'idcard',
    /** 手写签名（C-23：旧版报名方式的「签名承诺」题） */
    SIGNATURE: 'signature',
    /** 行政区划三级选择 + 详细地址（C-10 区域匹配的前提；D-05 裁决） */
    REGION: 'region',
};
/** 可用于计费的字段类型（§3.2「是否可用于计费」列） */
exports.PRICE_ELIGIBLE_FIELD_TYPES = [exports.FieldType.SELECT, exports.FieldType.RADIO];
/** 需要 `options` 的字段类型 */
exports.OPTION_FIELD_TYPES = [
    exports.FieldType.SELECT,
    exports.FieldType.RADIO,
    exports.FieldType.CHECKBOX,
];
/** 是否可上传的字段类型 */
exports.UPLOAD_FIELD_TYPES = [exports.FieldType.UPLOAD];
/**
 * `upload` 字段允许多份时的**张数上限兜底值**（字段未配 `maxCount` 时用它）。
 *
 * 为什么要有硬上限：附件是**跟着报名单永久留存**的（见 `docs/02-domain/07-留存与合规.md`），
 * 无上限等于把存储成本交给学员点击次数。5 份足够覆盖「工作证明 / 学历证明 / 合同」这类
 * 现实场景；确实更多的场景应该拆成多个字段，而不是把一个字段做成相册。
 */
exports.UPLOAD_DEFAULT_MAX_COUNT = 5;
/**
 * `maxCount` 的**硬上限**（配置层不允许超过）。
 *
 * 与兜底值分开的原因：兜底值可以调，硬上限是「再多就该拆字段」的分界线。
 * 请求侧另有 SM-3 的单文件体积限制，两者相乘是单字段的最坏存储占用。
 */
exports.UPLOAD_MAX_COUNT_LIMIT = 20;
/** 字段编辑分级（§3.3）：提交后的可编辑性 */
exports.FieldEditable = {
    /** 自由修改 */
    FREE: 'free',
    /** 需复审（触发资料补交判定，后台放行后才生效） */
    REVIEW: 'review',
    /** 永久锁定（如身份证号） */
    LOCKED: 'locked',
};
/** 条件显示运算符（§3.4）。一期**仅单条件**，不支持嵌套 */
exports.VisibleWhenOperator = {
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
};
/** 字段键的命名约束：字母开头，字母 / 数字 / 下划线，≤64 */
exports.FIELD_KEY_PATTERN = /^[a-zA-Z][a-zA-Z0-9_]{0,63}$/;
//# sourceMappingURL=form-schema.js.map